import React, { type FC, type JSX } from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { Icon } from '@/app/common/icons/Icon';
import { ArrowCircle, ArrowContainer } from './styled';

type ArrowProps = {
  isRightArrow?: boolean;
  handleArrowClick: (val: string) => void;
  noShadow?: boolean;
};

const Arrow: FC<ArrowProps> = ({ isRightArrow, handleArrowClick, noShadow }): JSX.Element => {
  const { externalHeaderEnabled } = useCommonClient();

  return (
    <ArrowContainer isRightArrow={isRightArrow} externalHeaderEnabled={externalHeaderEnabled}>
      <ArrowCircle noShadow={noShadow} onClick={() => handleArrowClick(isRightArrow ? 'right' : 'left')}>
        <Icon
          category="Arrows"
          name="icon-small-chevron-down"
          size={20}
          color="iconPrimary"
          alt={isRightArrow ? 'right' : 'left'}
        />
      </ArrowCircle>
    </ArrowContainer>
  );
};

export default Arrow;
